import request from 'configuration/request';
import { httpBuildQuery } from 'helpers/utils';

export const balanceApi = {
  getBalanceList: (params) => {
    return request({
      url: `/balance/list/${httpBuildQuery(params)}`,
      method: 'GET',
    });
  },

  getCurrentBalance: (id, params = {}) => {
    return request({
      url: `/balance/${id}/${httpBuildQuery(params)}`,
      method: 'GET',
    });
  },
  
  updateBalance: (balanceId, data) => {
    return request({
      url: `/balance/${balanceId}/`,
      method: 'PATCH',
      data,
    });
  },

  getCategories: () => {
    return request({
      url: '/category/list/',
      method: 'GET',
    });
  },

  getSubTypes: () => {
    return request({
      url: '/sub_type/list/',
      method: 'GET',
    });
  },

  calculateInstrument: (instrument) => {
    return request({
      url: '/chosen_item/get_sum/',
      method: 'POST',
      data: instrument,
    });
  },
  calculateInstrumentAmount: (instrument) => {
    return request({
      url: '/chosen_item/get_amount/',
      method: 'POST',
      data: instrument,
    });
  },
  calculateInstrumentAmountContinue: (instruments) => {
    return request({
      url: '/chosen_item/get_amount_list/',
      method: 'POST',
      data: instruments,
    });
  },
};
